export default __webpack_public_path__ + "static/media/h2.d4bcee05.webp";